import PrintServer from "../";

const routes = [
    { name: "PrintServerList", path: "/printserver", component: PrintServer.PrintServerList, meta: { title: "PrintServer" } },
    { name: "PrintServerView", path: "/printserver/view/:id", component: PrintServer.PrintServerView, meta: { title: "PrintServer View" } },
    { name: "PrintServerEdit", path: "/printserver/edit/:id", component: PrintServer.PrintServerEdit, meta: { title: "PrintServer Edit" } },
];

export default routes;
